import { FunctionComponent } from "react";
import Billing from "src/components/billing";
import CardManagement from "src/components/billing/CardManagement";
import ResetPasswordForm from "src/components/forms/auth/ResetPasswordForm";
import { LoadingSpinner, PageContainer, PageTitle } from "src/components/generic";
import SquareTile from "src/components/generic/tiles/SquareTile";
import { useAuth } from "src/context/AuthContext";

const Account: FunctionComponent = () => {
  const { user } = useAuth();

  return (
    <PageContainer>
      <PageTitle title="Account Details" />

      {
        !user ? <LoadingSpinner />
        : (
          <>
            <SquareTile title="Password Reset">
              <p className="my-6">Enter information below and check email for verification ccode:</p>
              <ResetPasswordForm />
            </SquareTile>

            <SquareTile title="Your Subscription">
              <p className="my-6">Account Type: {user.userType}</p>
              {user?.metadata?.stripeId ? (
                <>
                  <CardManagement customerId={user.metadata.stripeId} />
                  <Billing />
                </>
              ) : (
                <p className="text-sm opacity-80">No Stripe customer id found.</p>
              )}
            </SquareTile>       
          </>
        )
      }
    </PageContainer>
  );
};

export default Account;
